export default {"src":"https://cloudflare.edhrec.com/_next/static/media/manabrgw.10defc81.svg","height":100,"width":100,"blurWidth":0,"blurHeight":0};